import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import bannerImg from 'assets/wellbeing/AUTOCUIDAD-BANNER-TOP.webp';
import { HeroBanner } from 'components/HeroBanner';
import { categories } from './categories';
import { WellBeingCard } from './components/WellBeingCard';

export const WellBeing = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.WELL_BEING);

  return (
    <div className="space-y-8">
      <HeroBanner image={bannerImg} alt={t('WellBeing.heading')} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map(category => (
          <WellBeingCard key={category.id} category={category} />
        ))}
      </div>
    </div>
  );
};
